export const LabsHeroWidgetConfig = [
    // Main container with left content and right big box
    {
        classes: "flex gap-32",
        columns: [
            // Left side - Main content (13 columns)
            {
                span: 13,
                classes: "flex flexColumn",
                rows: [
                    // Title skeleton
                    { height: "48px", span: 12, classes: "marginBottom-24" },

                    // Search bar skeleton
                    { height: "56px", span: 12, classes: "marginBottom-24" },

                    // Quick actions row (3 items)
                    { height: "48px", span: 12, classes: "marginBottom-24" },

                    // Find Package section title
                    { height: "20px", span: 12, classes: "marginBottom-16" },

                    // Find Package grid (2 rows of 3 items each)
                    { height: "80px", span: 12, classes: "marginBottom-16" },
                    { height: "80px", span: 12, classes: "marginBottom-24" },
                ],
            },
            // Right side - One big box (11 columns)
            { height: "600px", span: 11 },
        ],
    },
]
